<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <BjDivider>{{ $t('SettingBaseDataLovHeader.table.basicInformation') }}</BjDivider>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataLovHeader.name')" prop="lovName">
        <BjInput
          v-model="form.lovName"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <BjFormItemCode v-model="form.lovCode" :rules="rules.lovCode" :label="$t('SettingBaseDataLovHeader.code')" prop="lovCode" />
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { baseDataApi } from '@/api';

const getDefaultForm = (tenantId = 0) => {
  return {
    enabledFlag: 1,
    lovCode: null,
    lovName: null,
    lovTypeCode: 'IDP',
    mustPageFlag: 1,
    parentLovCode: null,
    parentLovName: null,
    parentTenantId: tenantId,
    publicFlag: 0,
    routeName: null,
    source: null,
    tenantId: tenantId,
    tenantName: null,
    translationSql: null,
    valueField: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        lovName: [{ required: true, message: this.$t('SettingBaseDataLovHeader.table.nameText'), trigger: 'blur' }],
        lovCode: [{ required: true, message: this.$t('SettingBaseDataLovHeader.table.codeText'), trigger: 'blur' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!(info && info.lovCode);
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('SettingBaseDataLovHeader.table.edit') : this.$t('SettingBaseDataLovHeader.table.add'));
      this.form = Object.assign(getDefaultForm(this.$store.getters.tenantId), info || {});
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      API_DATA.parentLovCode = API_DATA.lovCode;
      API_DATA.parentLovName = API_DATA.lovName;
      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },

    addApi(API_DATA) {
      baseDataApi.addlovHeaders(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      baseDataApi.updatelovHeaders(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
